export const editorAutoSaveDelay = 1000;
// 15 mins in ms (900000)
export const editorVersionAutoCreationDelay = 900000;

export const defaultExtractContentEditorContent = '<p></p>';
export const defaultBriefOutlineContent = '<h1></h1>';
export const editorEvents = {
    selectionUpdate: 'selectionUpdate',
};

export const editorCommands = {
    undo: 'undo',
    redo: 'redo',
};

export const editorTypes = {
    OPTIMIZER: 'optimizer',
    OUTLINE: 'outline',
};

export const copyPasteOutlineContentPrefix = '__outline__';
